import { render, staticRenderFns } from "./m-language-select.vue?vue&type=template&id=4e26a147&scoped=true&"
import script from "./m-language-select.js?vue&type=script&lang=js&"
export * from "./m-language-select.js?vue&type=script&lang=js&"
import style0 from "./m-language-select.scss?vue&type=style&index=0&id=4e26a147&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e26a147",
  null
  
)

export default component.exports